import { SubdomainViewModel } from "@biz-models/login.model";
import { TokenSelector, userAccountDetails } from "@biz-store/auth/feature.selectors";
import { createSelector } from "@ngrx/store";

export const SubdomainList = createSelector(TokenSelector, userAccountDetails, (state, tenantAccount) =>
	state.loginResp
		?.filter((value) => {
			return tenantAccount.ListTenantAccount.find((v) => v.subdomain != value.subdomain);
		})
		.map(
			(i) =>
				({
					companyName: i.company_name,
					subdomain: i.subdomain,
					userName: i.user.name,
					token: i.token,
					signature: i.signature,
					redirect: i.redirect,
					server: i.server,
					subdomain_type: i.subdomain_type,
				} as SubdomainViewModel),
		),
);
